



















































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { vuex } from "@/store";
import router from "@/router";
import QuizPlayer from '../components/ExerciseComponents/QuizPlayer.vue';
import ScormPlayer from '../components/ExerciseComponents/ScormPlayer.vue';
import ExFinished from '../components/ExerciseComponents/ExFinished.vue';
import { ExDataSet, ExChoice, ExQuestion } from '../interfaces/ExDataSet';
import { ExerciseVM } from '../interfaces/ExerciseVM';
// import { ExBundleVM } from '@/interfaces/ExBundleVM';
import de from 'vuetify/src/locale/de';
import { ExBundleAssignmentVM } from "@/interfaces/ExBundleAssignmentVM";

const globals = namespace("globals");
const ux = namespace("ux");
const quizplayerstore = namespace("quizplayerstore");

@Component({
  components: {
    QuizPlayer,
    ScormPlayer,
    ExFinished
  }
})
export default class Exercise extends Vue {
  @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter selectedExBundleAssignment!: ExBundleAssignmentVM;
  @ux.State reserveSpaceForDrawer: any;
  @quizplayerstore.Action writeModuleSaveState!: () => void;

  pageProgress: number = 0;
  pageCount: number = 0;
  pageIndex: number = 0;
  scoreValue: number = 0;
  showFinishDialog: boolean = false;
  resultInPercent: number = 0;

  // $refs!: {};

  // breadcrumbItems = [
  //   { text: 'Start', disabled: false, href: '/home' },
  //   { text: 'Schulungen', disabled: true, href: '/exercises' },
  // ];

  mounted() {
    if (this.selectedExercise == null) {
      router.push("/");
      return;
    }

    this.$globalHelper.scrollToTop();
  }

  beforeDestroy() {
    // console.log("Exercise.vue beforeDestroy");
    if (!this.selectedExBundleAssignment.exBundle) return;

    // this.selectedExBundleAssignment.exBundle.sequentialModuleProcessing &&
    if (this.selectedExBundleAssignment.writeResults) {
      this.writeModuleSaveState();
    }
  }

  @Watch("showFinishDialog")
  async onShowFinishDialogChanged(val: boolean) {
    if (!this.showFinishDialog) {
      // window.alert("Finish dialog closed!");
      this.goBack();
    }
  }

  setProgress(pageIndex: number, pageCount: number, scoreValue?: number) {
    this.pageCount = pageCount;
    this.pageIndex = pageIndex;
    if (pageCount > 0) {
      this.pageProgress = (pageIndex / (pageCount - 1)) * 100;
    } else {
      this.pageProgress = 0;
    }

    if (scoreValue !== undefined) {
      this.scoreValue = scoreValue;
    }
  }

  get requiredScore() {
    if (this.selectedExercise.type == "Test" || this.selectedExercise.type == "Explanation") {
      return this.selectedExercise.requiredScoreValue;
    }
    return 0;
  }

  quizFinished(resultInPercent: number) {
    this.resultInPercent = resultInPercent;
    if (
      this.selectedExercise.type == "Rule" ||
      this.selectedExercise.type == "Explanation" ||
      this.selectedExercise.type == "ExplanationVideo" ||
      this.selectedExercise.type == "Signature"
    ) {
        this.goBack();
    } else {
        this.showFinishDialog = true;
    }
  }

  get fitView() {
    return this.reserveSpaceForDrawer ? "calc(100vw - 256px)" : "100vw";
  }

  get requiredMarkerStyle() {
    const size = 28; // matches :size on v-progress-circular
    const radius = size / 2;
    const markerHeight = 8; // length of the small tick
    const rotateOffset = 0; // v-progress-circular uses rotate="-90"
    const angle = (this.requiredScore / 100) * 360 + rotateOffset;
    const translateY = -(radius - markerHeight / 2);
    return {
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: '2px',
      height: markerHeight + 'px',
      background: this.$store.state.ux.colorWarning || '#f39c12',
      transform: `translate(-50%,-50%) rotate(${angle}deg) translateY(${translateY}px)`,
      transformOrigin: 'center center',
      borderRadius: '1px',
      zIndex: 3,
    };
  }

  async goBack() {
    // console.log("this.selectedExercise.type", this.selectedExercise.type);
    if (this.selectedExercise.type?.toLowerCase() == "scorm") {
      // console.log("Exercises.vue: For SCORM exercises navigate to /exerciseBundle")
      // router.push("/exerciseBundle");
      console.log("Exercises.vue: navigateBackToSavedRouteName for SCORM exercise");
      vuex.quizplayerstore.navigateBackToSavedRouteName();
      return;
    }

    // console.log("Exercises.vue: goBack()");
    router.go(-1);
  }
}
